import {Component, Injector} from '@angular/core';
import {TransporterDiscountState, Store} from './state/store';
import {TransporterDiscount} from './state/model';
import {EntityListComponent} from '../../components/entity-list/component';
import {FilterService} from './filter.service';
import {TransporterDiscountQuery} from './state/query';
import {TransporterDiscountService} from './state/service';

@Component({
  templateUrl: '../../components/entity-list/component.html',
  styleUrls: ['../../components/entity-list/component.scss']
})
export class TransporterDiscountListComponent extends EntityListComponent<TransporterDiscount, TransporterDiscountState, Store> {

  translationDomain = 'transporter-discount';

  constructor(
    public injector: Injector,
    protected service: TransporterDiscountService,
    query: TransporterDiscountQuery,
    private TransporterDiscountFilterService: FilterService) {
    super(injector, service, query, TransporterDiscountFilterService);
  }
  canEdit(): boolean {
    return this.hasRole('ROLE_ADMIN');
  }
}
